import * as React from 'react';
import { ArticleHeading5 } from '@cian/ui-kit/typography';

import * as styles from './styles.css';

export interface ICircularProgressBarProps {
  size?: number;
  strokeWidth?: number;
  progressPercentage: number;
  count?: number;
  maxCount?: number;
}

export const CircularProgressBar: React.FC<React.PropsWithChildren<ICircularProgressBarProps>> = ({
  progressPercentage,
  size = 10,
  strokeWidth = 4,
  count,
  maxCount,
}) => {
  const showCounter = maxCount || count;
  const circleLength = 2 * Math.PI * size;
  const progressFill = (circleLength / 100) * progressPercentage;
  const containerSize = size * 2 + strokeWidth;
  const counterValueColor = count ? 'black_100' : 'gray40_100';

  return (
    <div className={styles['wrapper']} style={{ width: containerSize, height: containerSize }}>
      {showCounter && (
        <div className={styles['counter']}>
          <ArticleHeading5 color={counterValueColor}>
            {count}
            <span className={styles['max-count']}>/{maxCount}</span>
          </ArticleHeading5>
        </div>
      )}
      <svg className={styles['svg']}>
        <circle className={styles['base-circle']} r={size} cx="50%" cy="50%" fill="none" strokeWidth={strokeWidth} />

        <circle
          className={styles['fill-circle']}
          r={size}
          cx="50%"
          cy="50%"
          fill="none"
          strokeWidth={strokeWidth}
          strokeDasharray={`${progressFill} ${circleLength}`}
        />
      </svg>
    </div>
  );
};

CircularProgressBar.displayName = 'CircularProgressBar';
